import React from 'react';
import { Link } from 'react-router-dom';

import Imagem from 'Component/Imagem';
import Categoria from 'Interface/Categorias';

interface Props {
    dados: Categoria;
}

const Cartao = ({ dados }: Props): React.ReactElement =>
{
    return (
        <div className="position-relative hf-200">
            <Link
                to={ `/estudar/categoria/${dados.slug}` }
                className="text-center text-white text-decoration-none"
            >
                <Imagem
                    src={ dados.imagem }
                    className={ [
                        'w-100 mh-100',
                        'position-absolute z-index-500',
                        'object-fit-cover',
                        'rounded-3',
                    ].class() }
                />
                <p
                    className={ [
                        'w-100 p-3 mb-0',
                        'position-absolute bottom-0 z-index-1000',
                        'fs-4 fw-light text-white',
                        'bg-gradient-black-to-top',
                        'rounded-bottom'
                    ].class() }
                >
                    { dados.nome }
                </p>
            </Link>
        </div>
    );
}

export default Cartao;
